class ProductFormController {
  constructor(root) {
    this.root = root;
    this.form = root.closest('form');
    if (!this.form) return;

    this.track = root.querySelector('.pack-options');
    this.allVariants = [...root.querySelectorAll('.pack-option input')];
    this.enabledVariants = this.allVariants.filter(i => !i.disabled);

    this.oneTimeRadio = this.form.querySelector(
      'input[name="purchase_type"][value=""]'
    );
    this.subscribeRadio = this.form.querySelector(
      'input[name="purchase_type"][value="subscription"]'
    );

    this.oldPriceEls = this.form.querySelectorAll('.price-old');
    this.newPriceEls = this.form.querySelectorAll('.price-new');
    this.saveEls = this.form.querySelectorAll('.price-save');
    this.otPriceEls = this.form.querySelectorAll(
      '.sl-purchase-option:not(.sl-subscribe) .sl-price'
    );
    this.subscribePriceEls = this.form.querySelectorAll(
      '.sl-purchase-option.sl-subscribe .sl-price'
    );

    this.atcButton = this.form.querySelector('.button--add-to-cart');
    this.sellingPlanSelect = this.form.querySelector('[data-selling-plan]');
    this.sellingPlanInput = this.form.querySelector(
      'input[name="selling_plan"]'
    );

    this.initIndicator();
    this.bindEvents();
    this.syncAll(true);
    this.forceClearIfOneTime();
    this.bindSubmitGuard();
  }

  initIndicator() {
    if (!this.track) return;
    this.indicator = document.createElement('div');
    this.indicator.className = 'pack-indicator';
    this.track.style.setProperty('--count', this.allVariants.length);
    this.track.prepend(this.indicator);
  }

  bindEvents() {
    this.enabledVariants.forEach(i =>
      i.addEventListener('change', () => this.syncAll())
    );

    this.oneTimeRadio?.addEventListener('change', () =>
      this.forceClearIfOneTime()
    );

    this.subscribeRadio?.addEventListener('change', () =>
      this.syncPurchaseType()
    );

    this.sellingPlanSelect?.addEventListener('change', () => {
      if (this.subscribeRadio?.checked) {
        this.syncSellingPlan();
      }
    });
  }

  bindSubmitGuard() {
    this.form.addEventListener('submit', () => {
      if (this.oneTimeRadio?.checked && this.sellingPlanInput) {
        this.sellingPlanInput.value = '';
      }
    });
  }

  syncAll(initial = false) {
    this.syncVariantIndicator(initial);
    this.updatePrices();
    this.toggleAddToCart();
    this.syncPurchaseType();
  }

  syncVariantIndicator(initial) {
    if (!this.indicator) return;
    const index = this.allVariants.findIndex(i => i.checked);
    if (index < 0) return;

    this.indicator.classList.remove('is-settling');
    this.indicator.style.setProperty('--pos', index);

    if (!initial) {
      this.allVariants.forEach(i =>
        i.closest('.pack-option')?.classList.remove('is-animate')
      );

      this.allVariants[index]
        .closest('.pack-option')
        ?.classList.add('is-animate');

      requestAnimationFrame(() =>
        this.indicator.classList.add('is-settling')
      );
    }
  }

  updatePrices() {
    const v = this.getSelectedVariant();
    if (!v) return;

    const price = v.dataset.price;
    const compare = v.dataset.compare;
    const sub = v.dataset.planPrice;

    const p = this.toNumber(price);
    const c = this.toNumber(compare);

    this.newPriceEls.forEach(el => (el.textContent = price || ''));
    this.otPriceEls.forEach(el => (el.textContent = price || ''));
    this.oldPriceEls.forEach(el => (el.textContent = compare || ''));
    this.subscribePriceEls.forEach(el => (el.textContent = sub || ''));

    this.saveEls.forEach(el => {
      if (c > p) {
        const s = c - p;
        const pct = Math.round((s / c) * 100);
        el.style.display = '';
        el.innerHTML = `SAVE ${pct}% <span class="price-save-value">(${this.formatMoney(
          s
        )})</span>`;
      } else {
        el.style.display = 'none';
      }
    });
  }

  syncPurchaseType() {
    if (!this.sellingPlanInput) return;

    if (this.subscribeRadio?.checked) {
      this.syncSellingPlan();
    } else {
      this.sellingPlanInput.value = '';
    }
  }

  forceClearIfOneTime() {
    if (this.oneTimeRadio?.checked && this.sellingPlanInput) {
      this.sellingPlanInput.value = '';
    }
  }

  syncSellingPlan() {
    if (!this.subscribeRadio?.checked) return;
    if (!this.sellingPlanSelect || !this.sellingPlanInput) return;

    let opt = this.sellingPlanSelect.querySelector('option:checked');
    if (!opt) {
      opt = this.sellingPlanSelect.options[0];
      if (opt) opt.selected = true;
    }

    this.sellingPlanInput.value = opt?.dataset?.value || '';
  }

  toggleAddToCart() {
    const v = this.getSelectedVariant();
    if (!this.atcButton) return;

    if (!v || v.disabled) {
      this.atcButton.disabled = true;
      this.atcButton.classList.add('is-disabled');
      this.atcButton.querySelector('.text').textContent = 'Sold Out';
    } else {
      this.atcButton.disabled = false;
      this.atcButton.classList.remove('is-disabled');
      this.atcButton.querySelector('.text').textContent = 'Add to Cart';
    }
  }

  getSelectedVariant() {
    return this.root.querySelector('.pack-option input:checked');
  }

  toNumber(m) {
    return m ? parseFloat(m.replace(/[^0-9.]/g, '')) : 0;
  }

  formatMoney(v) {
    return `$${v.toFixed(2).replace('.00', '')}`;
  }
}


(function () {
  if (window.__productFormObserver) return;
  window.__productFormObserver = true;

  function init(el) {
    if (el.__productFormController) return;
    el.__productFormController = new ProductFormController(el);
  }

  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (!(node instanceof HTMLElement)) return;

        if (node.matches?.('.pack-toggle')) {
          init(node);
        }

        node.querySelectorAll?.('.pack-toggle').forEach(init);
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

